import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ErrorMessageDirective } from '../../../directives/error-message.directive';
import { MiscModule } from '../../../misc.module';
import { SendDocumentModalComponent } from './send-document-modal/send-document-modal.component';
import { TransactionHistoryPageRoutingModule } from './transaction-history-routing.module';
import { TransactionHistoryPageComponent } from './transaction-history.page';

@NgModule({
  declarations: [TransactionHistoryPageComponent, SendDocumentModalComponent],
  imports: [
    FormsModule,
    IonicModule,
    TransactionHistoryPageRoutingModule,
    MiscModule,
    CommonModule,
    ReactiveFormsModule,
    ErrorMessageDirective
  ]
})
export class TransactionHistoryPageModule {}
